import { render, staticRenderFns } from "./RemarkEditDialog.vue?vue&type=template&id=b6135fea&lang=pug"
import script from "./RemarkEditDialog.vue?vue&type=script&lang=js"
export * from "./RemarkEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports